<template>
  <!--
    ปุ่มชุดต่ออายุ — ใช้ร่วมกันที่หน้าล็อก (LicenseLockScreen) และ popup เตือน (LicenseReminder)
      แถวบน  : LINE ปุ่มหลักเต็มแถว — เปิดแชต OA พร้อมพิมพ์ "ขอต่ออายุ · ร้าน · โดเมน" ไว้ให้ ร้านแค่กดส่ง
      แถวล่าง : ดูแพ็กและราคา (เว็บ sivapos.com) · โทร — ปุ่มรองขนาดเท่ากัน
    LINE เด่นสุดโดยตั้งใจ (ตอบได้เร็วกว่า และรู้ทันทีว่าร้านไหน) · โทรเป็นทางรอง
  -->
  <div class="license-contact">
    <a
      v-if="contact.line"
      :href="lineHref"
      target="_blank"
      rel="noopener"
      class="license-contact__line"
    >
      <i class="fa-brands fa-line license-contact__line-icon" />
      <span class="license-contact__line-text">
        <span class="license-contact__line-label">{{ $t('_license.Renew via LINE') }}</span>
        <span class="license-contact__line-id">{{ contact.line }}</span>
      </span>
      <i class="fa-solid fa-chevron-right license-contact__line-arrow" />
    </a>

    <div class="license-contact__row">
      <a
        v-if="contact.plansUrl"
        :href="contact.plansUrl"
        target="_blank"
        rel="noopener"
        class="license-contact__soft"
      >
        <i class="fa-solid fa-tags" />{{ $t('_license.See plans and prices') }}
      </a>
      <a v-if="contact.phone" :href="telHref" class="license-contact__soft">
        <i class="fa-solid fa-phone" />{{ contact.phone }}
      </a>
    </div>
  </div>
</template>

<script>
import { SUPPORT_CONTACT, lineRenewUrl } from '@/stores/license.store';

export default {
  name: 'LicenseContact',
  computed: {
    contact() {
      return SUPPORT_CONTACT;
    },
    // ชื่อร้านภาษาไทยก่อน — ข้อความนี้ส่งถึงเรา ไม่ได้โชว์ให้ร้านอ่าน
    lineHref() {
      return lineRenewUrl(this.$brand.name || this.$brand.name_en);
    },
    // ตัดขีดออกก่อนใส่ tel: — เบอร์ที่โชว์อ่านง่าย (098-2299881) แต่ที่กดโทรต้องเป็นตัวเลขล้วน
    telHref() {
      return `tel:${String(SUPPORT_CONTACT.phone).replace(/[^0-9+]/g, '')}`;
    }
  }
};
</script>

<style scoped>
.license-contact {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ── LINE: ปุ่มหลัก เขียว LINE ทางการ ให้จำได้ทันทีว่ากดแล้วเปิดไลน์ ── */
.license-contact__line {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  background: #06c755;
  color: #fff;
  text-align: left;
  text-decoration: none;
  box-shadow: 0 0.375rem 1rem rgba(6, 199, 85, 0.3);
  transition: background 0.15s, transform 0.15s;
}

.license-contact__line:hover,
.license-contact__line:focus-visible {
  background: #05b04b;
  color: #fff;
  transform: translateY(-1px);
}

.license-contact__line-icon {
  font-size: 1.875rem;
  flex-shrink: 0;
}

.license-contact__line-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.25;
}

.license-contact__line-label {
  font-size: 1.0625rem;
  font-weight: 700;
}

.license-contact__line-id {
  font-size: 0.8125rem;
  opacity: 0.85;
}

.license-contact__line-arrow {
  font-size: 0.875rem;
  opacity: 0.8;
}

/* ── ปุ่มรอง 2 ช่องเท่ากัน ── */
.license-contact__row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 0.5rem;
}

.license-contact__soft {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.625rem 0.5rem;
  border-radius: 0.75rem;
  background: #f1f5f9;
  color: #334155;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.15s;
}

.license-contact__soft:hover,
.license-contact__soft:focus-visible {
  background: #e2e8f0;
  color: #0f172a;
}

.license-contact__soft .fa-solid {
  color: #64748b;
}
</style>
